<template>
<div>
    <div class="modal fade" role="dialog" id="GrupoWorkerModal">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ tipo }} grupo de workers</h4>
                </div>
                <form @submit.prevent="enviar">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Nombre</label>
                            <input class="form-control" type="text" v-model.trim="form.nombre"
                                placeholder="ej. email-default-sms">
                            <small class="text-muted">Solo letras, números, guiones y guiones bajos.</small>
                        </div>

                        <div class="form-group">
                            <label>Procesos (numprocs)</label>
                            <input class="form-control" type="number" min="1" v-model.number="form.procesos">
                        </div>

                        <div class="form-group">
                            <label>Colas (orden = prioridad)</label>
                            <div v-for="(cola, index) in form.colas" :key="index" class="input-group mb-1">
                                <input class="form-control" type="text" v-model.trim="form.colas[index]"
                                    placeholder="nombre de la cola">
                                <div class="input-group-append">
                                    <button class="btn btn-default" type="button" @click="subir(index)" :disabled="index === 0">
                                        <i class="fal fa-arrow-up"></i>
                                    </button>
                                    <button class="btn btn-default" type="button" @click="bajar(index)" :disabled="index === form.colas.length - 1">
                                        <i class="fal fa-arrow-down"></i>
                                    </button>
                                    <button class="btn btn-danger" type="button" @click="quitarCola(index)">
                                        <i class="fal fa-times"></i>
                                    </button>
                                </div>
                            </div>
                            <button class="btn btn-default btn-sm" type="button" @click="agregarCola">
                                <i class="fal fa-plus"></i> Agregar cola
                            </button>
                        </div>

                        <div class="form-group">
                            <label class="d-block">Activo</label>
                            <input type="checkbox" v-model="form.activo"> Grupo activo
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-default" type="button" @click="hide">Cancelar</button>
                        <button class="btn-primary btn" type="submit">{{ tipo }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        tipo: { type: String, default: 'Agregar' },
        grupo: { type: Object, default: null },
    },
    data() {
        return {
            form: this.formVacio(),
        };
    },
    methods: {
        formVacio() {
            return { nombre: '', procesos: 1, colas: [''], activo: true };
        },
        show(grupo) {
            // Usar el grupo recibido por argumento (evita depender de que el prop
            // ya se haya propagado: por eso antes no cargaba en la 1ª apertura).
            var g = (typeof grupo !== 'undefined') ? grupo : this.grupo;
            if (g) {
                this.form = {
                    nombre: g.nombre,
                    procesos: g.procesos,
                    colas: (g.colas && g.colas.length) ? g.colas.slice() : [''],
                    activo: !!g.activo,
                };
            } else {
                this.form = this.formVacio();
            }
            $('#GrupoWorkerModal').modal('show');
        },
        hide() {
            $('#GrupoWorkerModal').modal('hide');
        },
        agregarCola() {
            this.form.colas.push('');
        },
        quitarCola(index) {
            this.form.colas.splice(index, 1);
            if (this.form.colas.length === 0) this.form.colas.push('');
        },
        subir(index) {
            if (index === 0) return;
            const tmp = this.form.colas[index - 1];
            this.$set(this.form.colas, index - 1, this.form.colas[index]);
            this.$set(this.form.colas, index, tmp);
        },
        bajar(index) {
            if (index === this.form.colas.length - 1) return;
            const tmp = this.form.colas[index + 1];
            this.$set(this.form.colas, index + 1, this.form.colas[index]);
            this.$set(this.form.colas, index, tmp);
        },
        enviar() {
            const colas = this.form.colas.map(c => (c || '').trim()).filter(c => c !== '');
            this.$emit('guardar', {
                nombre: this.form.nombre,
                procesos: this.form.procesos,
                colas: colas,
                activo: this.form.activo,
            });
        },
    },
};
</script>
